module.exports = __webpack_public_path__ + "img/felec-w.3cb8cf31.jpg";